<template>
  <div>
    <div class="container">
      <h2 class="font-weight-bold font-size-medium text-center text-md-left">{{ title }}</h2>
      <div v-if="posts.length > 0">
        <PostThumbList
          class="mt-4"
          :posts="posts"
        />
        <div class="mt-4 text-center">
          <Button
            class="btn-outline-color2 btn-lg"
            :loading="loader"
            @click="loadMore"
            v-if="isLoadMoreVisible"
          >
            Carregar mais
          </Button>
        </div>
      </div>
      <p
        class="text-center mt-3"
        v-else-if="!loader"
      >Não foi encontrado nenhum texto</p>
      <Loader
        color="color2"
        size="big"
        v-else
      />
    </div>
  </div>
</template>

<script>

import FeedService from '@/modules/feed/services/feed-service'
import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button.vue'
import Loader from '@/components/common/Loader/Loader.vue'
import PostThumbList from '@/components/post/PostThumbList.vue'

export default {
  components: {
    Button,
    Loader,
    PostThumbList
  },
  data () {
    return {
      posts: [],
      page: 1,
      isLoadMoreVisible: true,
      loader: false
    }
  },
  metaInfo () {
    return {
      title: this.title
    }
  },
  created () {
    this.posts = []
    this.getPosts()
  },
  watch: {
    type () {
      this.posts = []
      this.getPosts()
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    type () {
      if (this.$route.name === 'feed.following') return 'following'
      else if (this.$route.name === 'feed.groups') return 'groups'
      else return this.$route.params.type
    },
    title () {
      switch (this.type) {
        case 'following':
          return 'Novidades de quem você segue'
        case 'trending':
          return 'Conteúdo em destaque no momento'
        case 'latest':
          return 'Conteúdo mais recente'
        case 'groups':
          return 'Novidades das suas comunidades'
        case 'scriv-pro':
          return 'Novidades de usuários Scriv Pro'
        default:
          return ''
      }
    }
  },
  methods: {
    async getPosts () {
      this.loader = true
      try {
        const type = this.type === 'scriv-pro' ? 'scriv_pro' : this.type
        const posts = await FeedService.getFeedPosts({ type: type, page: this.page, items: 9 })
        this.posts = [...this.posts, ...posts]
        if (posts.length <= 0) this.isLoadMoreVisible = false
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    },
    loadMore () {
      this.page++
      this.getPosts()
    },
    destroyPost (id) {
      const index = this.posts.findIndex(c => c.id === id)
      this.posts.splice(index, 1)
    }
  }
}
</script>
